/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TaxDocuments = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.49326 6C6.13963 6 5 7.10207 5 8.50686C5 9.89795 6.12618 11 7.49326 11C8.84179 11 10 9.93041 10 8.50686C10 7.1001 8.8449 6 7.49326 6ZM6.5 8.50686C6.5 7.93984 6.95868 7.5 7.49326 7.5C8.03791 7.5 8.5 7.9498 8.5 8.50686C8.5 9.06227 8.05364 9.5 7.49326 9.5C6.94508 9.5 6.5 9.06003 6.5 8.50686Z"
                        fill={color}
                    />
                    <path
                        d="M8.10812 15.6555L6.15179 15.6478L13.0437 6.15222L15 6.15995L8.10812 15.6555Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.25 13.2673C11.25 11.8625 12.3896 10.7604 13.7433 10.7604C15.0949 10.7604 16.25 11.8605 16.25 13.2673C16.25 14.6908 15.0918 15.7604 13.7433 15.7604C12.3762 15.7604 11.25 14.6584 11.25 13.2673ZM13.7433 12.2604C13.2087 12.2604 12.75 12.7003 12.75 13.2673C12.75 13.8205 13.1951 14.2604 13.7433 14.2604C14.3036 14.2604 14.75 13.8227 14.75 13.2673C14.75 12.7102 14.2879 12.2604 13.7433 12.2604Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19 1H2V20H19V1ZM3.5 18.5V2.5H17.5V18.5H3.5Z"
                        fill={color}
                    />
                    <path d="M20.5 5V21.5H6V23H22V5H20.5Z" fill={color} />
                </svg>
        );
    };
